/**
 * Environment palette lock — US 17.09. Exactly 32 colours; every WORLD
 * asset (tiles, props, vehicles) draws only from these, whatever its
 * source — asset pack, AI, commissioned. Character sprites and pictures
 * are exempt (free colour). A unit test enforces size, uniqueness and
 * that every named environment colour is a member.
 */

export const ENVIRONMENT_PALETTE: readonly number[] = [
  // Greens (grass, foliage)
  0x2e7d32, 0x4caf50, 0x66bb6a, 0x9ccc65,
  // Greys (road, sidewalk, stone, wall)
  0x263238, 0x455a64, 0x616161, 0x78909c, 0x9e9e9e, 0xcfd8dc,
  // Blues (water)
  0x0d47a1, 0x1976d2, 0x42a5f5, 0x90caf9,
  // Earth (sand, dock, doors, interior, bag)
  0xd7c27a, 0x8d6e63, 0xbca789, 0xb5651d, 0x795548, 0x5d4037, 0xa1887f,
  // Warm accents (interactive family, warnings)
  0xffd54f, 0xffb300, 0xff8f00,
  // Danger / vehicles
  0xd32f2f, 0xb71c1c, 0xe64a19,
  // Night / shadow / highlight
  0x212121, 0x37474f, 0xf5f5f5, 0xfff8e1, 0x1b5e20,
];

/** Named environment colours — the vocabulary textures.ts composes from. */
export const ENV = {
  grass: 0x4caf50,
  road: 0x616161,
  sidewalk: 0x9e9e9e,
  sand: 0xd7c27a,
  dock: 0x8d6e63,
  interior: 0xbca789,
  wall: 0x263238,
  water: 0x1976d2,
  door: 0xb5651d,
  carBody: 0xd32f2f,
  carWindow: 0x90caf9,
  carWheel: 0x212121,
  bagBody: 0x795548,
  bagNeck: 0x5d4037,
  accent: 0xffd54f,
  warning: 0xffb300,
  shadow: 0x212121,
} as const;
